import axios from "axios";

export let _localStorage = {};

export const updateLocalStorage = async () => {
  if (localStorage) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    localStorage.removeItem("role");
    window.location.replace("/");
  }
};

// RETURN TOKEN ACCORDING TO CURRENT PANEL USER
const returnToken = () => {
  return localStorage.getItem("accessToken");
};


export const baseUrl = process.env.REACT_APP_API_URL;

// INTERCEPTORS FOR REQUESTS

axios.interceptors.request.use(
  function (config) {
    config.headers.Authorization = returnToken();
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const post = async (url, data) => {
  try {
    const res = await axios.post(baseUrl + url, data);
    return { statusCode: res?.status, data: res?.data };
  } catch (e) {
    // Skip session-expiry redirect for login endpoint (401 = wrong credentials here, not expired session)
    const isLoginUrl = url.includes('/Customers/login');
    if (!isLoginUrl && e?.response?.data?.error?.statusCode === 401) {
      updateLocalStorage();
    }
    return {
      statusCode: e?.response?.data?.error?.statusCode || e?.response?.status || 404,
      message:
        e?.response?.data === undefined
          ? e?.message
          : e?.response?.data?.error?.message,
    };
  }
};

export const patch = async (url, data) => {
  try {
    const res = await axios.patch(baseUrl + url, data);
    return { statusCode: res?.status, data: res?.data };
  } catch (e) {
    if (e?.response?.data?.error?.statusCode === 401) {
      updateLocalStorage();
    }
    return {
      statusCode: e?.response?.data?.error?.statusCode || 404,
      message:
        e?.response?.data === undefined
          ? e?.message
          : e?.response?.data?.error?.message,
    };
  }
};

export const get = async (url) => {
  try {
    const res = await axios.get(baseUrl + url);
    return { statusCode: res?.status, data: res?.data };
  } catch (err) {
    if (err?.response?.data?.error?.statusCode === 401) {
      updateLocalStorage();
    }
    return {
      statusCode: err?.response?.data?.error?.statusCode || err?.response?.status || 404,
      message:
        err?.response?.data === undefined
          ? err?.message
          : err?.response?.data?.error?.message,
    };
  }
};

export const remove = async (url) => {
  try {
    const res = await axios.delete(baseUrl + url);
    return { statusCode: res?.status, data: res?.data };
  } catch (err) {
    if (err?.response?.data?.error?.statusCode === 401) {
      updateLocalStorage();
    }
    return {
      statusCode: err?.response?.data?.error?.statusCode || err?.response?.status || 404,
      message:
        err?.response?.data === undefined
          ? err?.message
          : err?.response?.data?.error?.message,
    };
  }
};